var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"change_local_mode"},[_c('a-button',{staticClass:"change_btn",attrs:{"icon":"swap","type":"link","size":"small"},on:{"click":_vm.toLocal}},[_vm._v(" "+_vm._s(_vm.$t('local_mode'))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }